import React from 'react';
import { useMsal } from '@azure/msal-react';
import { ApiService } from '../../../../../constants';
import { HttpService } from '../../../../../utilities';
import Grid from '../../../../../assets/icon/ic_beelajar_grid-on-sharp.svg';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import AppItem from './AppItem';

const ApplicationBar = (props) => {
  const { instance, accounts } = useMsal();

  let selectedAccount = accounts.find(
    (it) => it.username === props.user.userName
  );
  if (!selectedAccount) {
    selectedAccount = accounts[0];
  }

  const getAzureToken = (success, error) => {
    const _request = { scopes: ['User.Read'], account: selectedAccount };
    instance
      .acquireTokenSilent(_request)
      .then((tokenResponse) => {
        if (typeof success == 'function') {
          success(tokenResponse);
        }
      })
      .catch(async (err) => {
        console.error(err);
        if (typeof error == 'function') {
          error(err);
        }
        if (error instanceof InteractionRequiredAuthError) {
          return instance.acquireTokenPopup(_request);
        }
      });
  };

  const onClickLinkApp = (e, item) => {
    e.preventDefault();
    const email =
      props.user.emails && props.user.emails.length > 0
        ? props.user.emails[0]
        : '';
    switch (item.code) {
      case '001':
        if (email && email != '') {
          HttpService.goToBeelajar(
            email,
            ApiService.beelajar.externalTrainingRequest
          );
        } else {
          alert('User Unauthorized');
        }
        break;
      case '002':
        getAzureToken(
          (tokenResponse) => {
            HttpService.goToBclnDFrontEnd(tokenResponse.accessToken);
          },
          (err) => {
            alert('User Unauthorized');
          }
        );
        break;
      case '003':
        HttpService.post(ApiService.icdc.auth.getBclndOldBeToken, {})
          .then((resp) => {
            HttpService.goToBclnDOldBackEnd(resp.data.token);
          })
          .catch((err) => {});
        break;
      case '004':
        getAzureToken(
          (tokenResponse) => {
            HttpService.goToBclnDNewBackEnd(tokenResponse.accessToken);
          },
          (err) => {
            alert('User Unauthorized');
          }
        );
        break;
      case '005':
        getAzureToken(
          (tokenResponse) => {
            HttpService.goToFma(props.user.userName, tokenResponse.accessToken);
          },
          (err) => {
            alert('User Unauthorized');
          }
        );
        break;
    }
  };

  return (
    <div className="application-container">
      <a href="#" onClick={(e) => props.onBtnToogler(e)}>
        <img src={Grid} alt="grid-on-sharp" />
      </a>

      <h2>Apps</h2>
      <ul className="application-container__nav">
        {props.data &&
          props.data.length > 0 &&
          props.data.map((it, x) => {
            return (
              <AppItem key={x} it={it} id={x} onClickLinkApp={onClickLinkApp} />
            );
          })}
      </ul>
    </div>
  );
};

export default ApplicationBar;
